import React from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {selectDashboard} from "../../redux/slices/genericViewSelectorSlice";



const GenericViewSelector = ({views, name}) => {
    const selectedDashboard = useSelector(state => state.genericViewSelector.selectedDashboard?.[name]) ?? views?.[0] ?? "";
    const dispatch = useDispatch();

    const changeSelectedDashboard = (diff) => {
        const currentIndex = views.indexOf(selectedDashboard);
        const newIndex = currentIndex + diff >= views.length? 0 : (currentIndex + diff < 0 ? views.length - 1 : currentIndex + diff);
        dispatch(selectDashboard({name, view: views?.[newIndex]}))
    };

    return (
        <div className="year-selector">
            <Button type="button" icon="pi pi-chevron-left" onClick={() => changeSelectedDashboard(-1)} />
            <div className="current-year">{selectedDashboard}</div>
            <Button type="button" icon="pi pi-chevron-right" onClick={() => changeSelectedDashboard(1)} />
        </div>
    )
}

export default GenericViewSelector;
